<div style="position: relative;">
    <upp-thumb *ngIf="place" [uppDataid]="'user-place-' + place.name + '-select'"
        [card]="place.photo"
        [title]="place.name" 
        (click)="OnSelect()"
    ></upp-thumb>
    <ion-icon class="floating bottom right dark " name="person-outline"></ion-icon>  
</div>
